import { Entity, Field } from "typegraph";

@Entity({one: "countResult", many: "countResults"})
export default class CountResult {

	@Field()
	public count: number;

}



// WEBPACK FOOTER //
// ./src/panels/organizationParticipant/entities/CountResult.ts